var Utils = require('@amzn/aws-workdocs-web-client-common').Utils;

(function(angular) {
    'use strict';
    /**
     * This is the controller for the Activity Feed view. Don't be mislead by the name "analytics" in this codebase.
     */
    angular.module('GorillaBoy.Analytics')
        .controller('AnalyticsController', [
            '$rootScope',
            '$scope',
            'SourceConstant',
            'AppConstants',
            '$translate',
            '$log',
            '$q',
            '$sce',
            '$routeParams',
            '$location',
            '$filter',
            '$timeout',
            'SignalProvider',
            'FileService',
            'DocumentService',
            'DocumentUtilities',
            'AnalyticsService',
            'DateFormatter',
            'DateTimeService',
            'TypeaheadService',
            'FeatureManagerService',
            'Features',
            'MessageManager',
            'userInfo',
            'CompanionService',
            'BrowserService',
            'CompanionClientService',
            AnalyticsController
        ]);

    function AnalyticsController($rootScope,
            $scope,
            SourceConstant,
            AppConstants,
            $translate,
            $log,
            $q,
            $sce,
            $routeParams,
            $location,
            $filter,
            $timeout,
            SignalProvider,
            FileService,
            DocumentService,
            DocumentUtilities,
            AnalyticsService,
            DateFormatter,
            DateTimeService,
            TypeaheadService,
            FeatureManagerService,
            Features,
            MessageManager,
            userInfo,
            CompanionService,
            BrowserService,
            CompanionClientService) {

        $rootScope.preFetchSharedWithMeDebounced();
        var layoutViewTypes = AppConstants.LayoutViewTypes,
            //Regexp is borrowed from Lambda Java code base of Gorillaboy
            rootFolderRegexp = /^S-[^&]*&d-[0-9a-f]{10}$/,
            resourceTypes = AppConstants.ActivityResourceTypes,
            SkuTypes = AppConstants.SkuType;

        $scope.ViewTypes = AppConstants.ViewTypes;
        $scope.userInfo = userInfo;
        $scope.isBasicUser = (userInfo.SkuType === SkuTypes.BASIC) ? true : false;
        document.title =  $translate.instant('ANALYTICS.TITLE') + ' - ' + AppConstants.APP_NAME;

        var flagFlippedAfterGettingFirstTimeResults = false;

        //SECTION: Layout code
        $scope.layout = {
            queriedSearchFileName : "",
            partialContent: './analytics/content_partial.html',
            partialTitleBar: './analytics/title_bar.html',
            view: layoutViewTypes.VIEW_ANALYTICS_LAYOUT,
            hasRightSidebar: false,

            serviceError : false,
            loadMoreInProgress : false,
            searchInProgress : false,

            //Master copy of whether left sidebar should be shown/hidden.
            showLeftSidebar: $rootScope.showLeftSidebar,
            showFilterMenu : false,
            showRightSidebar: false,
            showUploadPane: false
        };
        var minimumDate = new Date(2017, 1, 15); //Month index starts from zero. This is the date activities will be enabled in production
        $scope.datePickerOptions = {
            minDate: new Date(minimumDate)
        };

        var EXPORT_ACTIVITY_MIN_COMPANION_VERSION = '1.0.57.0';

        var FILTER_TYPES  = {
            DATE: 'DATE',
            ACTIVITY_SCOPE: 'ACTIVITY_SCOPE',
            ACTOR: 'ACTOR',
            NEW_VERSION_OR_FOLDER : 'NEW_VERSION_OR_FOLDER',
            SHARED : 'SHARED',
            COMMENTS : 'COMMENTS',
            UNSHARED : 'UNSHARED',
            DELETED : 'DELETED',
            RENAMED : 'RENAMED',
            RECYCLED : 'RECYCLED',
            RESTORED : 'RESTORED',
            MOVED : 'MOVED',
            ADMIN : 'ADMIN',
            ANONYMOUS : 'ANONYMOUS',
            DOWNLOADED : 'DOWNLOADED',
            VIEWED : 'VIEWED'
        };

        //VERY IMPORTANT: First a top level object in this scope to hold all the form data in the view
        //If we don't do so, and rely on direct references to scope properties (viz. ng-model="userInput") then any intermediary
        //scopes created by ngIf or ngRepeat directives will mess up the input binding. Meaning the "userInput" will be created on those scopes instead
        //of this scope
        $scope.resetSearchForm = function() {
            $scope.queryFormData = {
                dateModified : 'ANY_TIME',
                activityScope : 'DIRECT',
                showSubFolderActivity : false,
                showSitewideActivity : false,
            };

            $scope.queryFormData.activityTypes = [{
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.NEW_VERSION_OR_FOLDER),
                type : FILTER_TYPES.NEW_VERSION_OR_FOLDER,
                criteria : ['DOCUMENT_VERSION_UPLOADED', 'FOLDER_CREATED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.DELETED),
                type : FILTER_TYPES.DELETED,
                criteria : ['DOCUMENT_VERSION_DELETED', 'FOLDER_DELETED', 'DOCUMENT_VERSIONS_DELETED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.MOVED),
                type : FILTER_TYPES.MOVED,
                criteria : ['DOCUMENT_MOVED', 'FOLDER_MOVED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.COMMENTS),
                type : FILTER_TYPES.COMMENTS,
                criteria : ['DOCUMENT_COMMENT_ADDED', 'DOCUMENT_ANNOTATION_ADDED', 'DOCUMENT_COMMENT_DELETED', 'DOCUMENT_ANNOTATION_DELETED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.RECYCLED),
                type : FILTER_TYPES.RECYCLED,
                criteria : ['DOCUMENT_RECYCLED', 'FOLDER_RECYCLED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.RENAMED),
                type : FILTER_TYPES.RENAMED,
                criteria : ['DOCUMENT_RENAMED', 'FOLDER_RENAMED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.RESTORED),
                type : FILTER_TYPES.RESTORED,
                criteria : ['DOCUMENT_RESTORED', 'FOLDER_RESTORED', 'DOCUMENT_VERSIONS_RECOVERED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.SHARED),
                type : FILTER_TYPES.SHARED,
                criteria : ['DOCUMENT_SHARED', 'FOLDER_SHARED', 'FOLDER_SHAREABLE_LINK_CREATED', 'FOLDER_SHARE_PERMISSION_CHANGED', 'DOCUMENT_SHAREABLE_LINK_CREATED', 'DOCUMENT_SHARE_PERMISSION_CHANGED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.UNSHARED),
                type : FILTER_TYPES.UNSHARED,
                criteria : ['DOCUMENT_UNSHARED', 'FOLDER_UNSHARED', 'FOLDER_SHAREABLE_LINK_REMOVED', 'DOCUMENT_SHAREABLE_LINK_REMOVED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.ANONYMOUS),
                type : FILTER_TYPES.ANONYMOUS,
                criteria : [ 'DOCUMENT_ANONYMOUS_LINK_CREATED', 'DOCUMENT_ANONYMOUS_LINK_REMOVED',  'DOCUMENT_ANONYMOUS_LINK_EXPIRYDATE_CHANGED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.DOWNLOADED),
                type : FILTER_TYPES.DOWNLOADED,
                criteria : [ 'DOCUMENT_VERSION_DOWNLOADED'],
                enabled : false
            }, {
                label : $translate.instant('ANALYTICS.FILTER.ACTIVITY_TYPE.' + FILTER_TYPES.VIEWED),
                type : FILTER_TYPES.VIEWED,
                criteria : ['DOCUMENT_VERSION_VIEWED'],
                enabled : false
            }];
            $scope.queryFormData.activityTypes.sort(function(a, b) {
                return a.label > b.label ? 1 : (a.label < b.label ? -1 : 0);
            });
        };
        $scope.resetSearchForm();

        $scope.dateOptions = [{
            label : $translate.instant('ANALYTICS.FILTER.TIME.ANY_TIME'),
            value : 'ANY_TIME'
        }, {
            label : $translate.instant('ANALYTICS.FILTER.TIME.TODAY'),
            value : 'TODAY'
        }, {
            label : $translate.instant('ANALYTICS.FILTER.TIME.YESTERDAY'),
            value : 'YESTERDAY'
        }, {
            label : $translate.instant('ANALYTICS.FILTER.TIME.LAST_7_DAYS'),
            value : 'LAST_SEVEN'
        }, {
            label : $translate.instant('ANALYTICS.FILTER.TIME.LAST_30_DAYS'),
            value : 'LAST_THIRTY'
        }, {
            label : $translate.instant('ANALYTICS.FILTER.TIME.CUSTOM'),
            value : 'CUSTOM'
        }];
        
        $scope.filterButtons = [];
        $scope.removeFilter = function(type) {
            switch(type) {
                case FILTER_TYPES.DATE:
                    //remove the date conditions
                    $scope.queryFormData.dateModified = 'ANY_TIME';
                    break;

                case FILTER_TYPES.ACTOR:
                    $location.search('actorId', null);
                    $location.search('actorName', null);
                    break;

                case FILTER_TYPES.ADMIN:
                	$scope.queryFormData.showSitewideActivity = false;
                    break;

                case FILTER_TYPES.NEW_VERSION_OR_FOLDER:
                case FILTER_TYPES.SHARED:
                case FILTER_TYPES.UNSHARED:
                case FILTER_TYPES.COMMENTS:
                case FILTER_TYPES.DELETED:
                case FILTER_TYPES.RENAMED:
                case FILTER_TYPES.RECYCLED:
                case FILTER_TYPES.RESTORED:
                case FILTER_TYPES.MOVED:
                case FILTER_TYPES.ANONYMOUS:
                case FILTER_TYPES.DOWNLOADED:
                case FILTER_TYPES.VIEWED:
                    $scope.queryFormData.activityTypes.some(function(activityType) {
                        if (activityType.type === type) {
                            activityType.enabled = false;
                            return true;
                        }
                    });
                    break;
                case FILTER_TYPES.ACTIVITY_SCOPE:
                    $scope.queryFormData.showSubFolderActivity = false;
                    break;
            }
            $scope.__queryFormDataCopy = $scope.queryFormData;
            $scope.applyFilter();
        };

        $scope.__createFilterButtons = function() {
            var queryFormData = $scope.queryFormData;
            $scope.filterButtons = [];
            queryFormData.activityTypes.forEach(function(activityType) {
                if (activityType.enabled) {
                    $scope.filterButtons.push({
                        type : activityType.type,
                        label : activityType.label
                    });
                }
            });
            if ($routeParams.actorId) {
                $scope.filterButtons.push({
                    type: FILTER_TYPES.ACTOR,
                    label: $translate.instant('ANALYTICS.FILTER.ACTOR', {
                        InitiatorActorName : $routeParams.actorName
                    })
                });
            }

            if (queryFormData.showSitewideActivity) {
                $scope.filterButtons.push({
                    type: FILTER_TYPES.ADMIN,
                    label: $translate.instant('ANALYTICS.FILTER.SITEWIDE_ACTIVITY')
                });
            }

            if (queryFormData.dateModified === 'TODAY') {
                $scope.filterButtons.push({
                    type: FILTER_TYPES.DATE,
                    label: $translate.instant('ANALYTICS.FILTER.TIME.TODAY')
                });
            } else if (queryFormData.dateModified === 'YESTERDAY') {
                $scope.filterButtons.push({
                    type: FILTER_TYPES.DATE,
                    label: $translate.instant('ANALYTICS.FILTER.TIME.YESTERDAY')
                });
            } else if (queryFormData.dateModified === 'LAST_SEVEN'){
                $scope.filterButtons.push({
                    type: FILTER_TYPES.DATE,
                    label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_7_DAYS')
                });
            } else if (queryFormData.dateModified === 'LAST_THIRTY'){
                $scope.filterButtons.push({
                    type: FILTER_TYPES.DATE,
                    label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_30_DAYS')
                });
            } else if (queryFormData.dateModified === 'CUSTOM') {

                if (queryFormData.endDate && queryFormData.startDate) {
                    $scope.filterButtons.push({
                        type: FILTER_TYPES.DATE,
                        label : $translate.instant('ANALYTICS.FILTER.TIME.BETWEEN', {
                            From : moment(queryFormData.startDate).format('MM/DD/YYYY'),
                            To : moment(queryFormData.endDate).format('MM/DD/YYYY')
                        })
                    });
                } else if (queryFormData.endDate && !queryFormData.startDate) {
                    $scope.filterButtons.push({
                        type: FILTER_TYPES.DATE,
                        label : $translate.instant('ANALYTICS.FILTER.TIME.BEFORE', {
                            To : moment(queryFormData.endDate).format('MM/DD/YYYY')
                        })
                    });
                } else if (!queryFormData.endDate && queryFormData.startDate) {
                    $scope.filterButtons.push({
                        type: FILTER_TYPES.DATE,
                        label : $translate.instant('ANALYTICS.FILTER.TIME.AFTER', {
                            From : moment(queryFormData.startDate).format('MM/DD/YYYY')
                        })
                    });
                }
            }

            if (queryFormData.showSubFolderActivity) {
                $scope.filterButtons.push({
                    type: FILTER_TYPES.ACTIVITY_SCOPE,
                    label: $translate.instant('ANALYTICS.FILTER.SUBFOLDER_ACTIVITY')
                });
            }
        };

        $scope.__queryFormDataCopy = null;
        $scope.showFilterMenu = function() {
            $scope.__queryFormDataCopy = angular.copy($scope.queryFormData);
            $scope.layout.showFilterMenu = !$scope.layout.showFilterMenu;
        };

        $scope.isDetailView = function() {
            return $scope.layout.documentId || $scope.layout.folderId;
        };

        $scope.hideFilterMenu = function(commitFlag) {
            if (!commitFlag) {
                $scope.queryFormData = $scope.__queryFormDataCopy;
                $scope.__queryFormDataCopy = null;
            }
            $scope.layout.showFilterMenu = !$scope.layout.showFilterMenu;
        };

        var queryCategory = 'USER_ACTIVITIES';
        $scope.searchResultGroups = [];

        $scope.keywordSearch = function() {
            // $scope.resetSearchParams();
            // when user does keyword search, then the resources in the query params should be overridden
            $location.search('folderId', null);
            $location.search('documentId', null);
            $location.search('resourceName', null);
            delete $scope.layout.queriedSearchFileName;
            $location.search('keyword', $scope.queryFormData.searchFileName);
        };

        $scope.actorSearch = function(actorId, actorName) {
            // $scope.resetSearchParams();
            $location.search('actorId', actorId);
            $location.search('actorName', actorName);
        };

        /**
         * We listen to DOM events happening on the ng-bind-html element and relay those events to this Controller using
         * Angular JS events.
         */
        $scope.$on(SignalProvider.ActivityFeed.FilterByInitiatorActor, function(event, activity) {
            $scope.actorSearch(activity.Fields.InitiatorActorId, activity.Fields.InitiatorActorName);
        });

        $scope.$on(SignalProvider.ActivityFeed.FilterByTargetActor, function(event, activity) {
            $scope.actorSearch(activity.Fields.TargetActorId, activity.Fields.TargetActorName);
        });

        $scope.$on(SignalProvider.ActivityFeed.FilterByCommentRecipient, function(event, activity) {
            $scope.actorSearch(activity.Fields.CommentRecipientId, activity.Fields.CommentRecipientName);
        });

        $scope.typeaheadVisible = false;
        $scope.$on('TYPEAHEAD_AUTOCOMPLETE_VISIBLE', function() {
            $scope.typeaheadVisible = true;
        });
        $scope.$on('TYPEAHEAD_AUTOCOMPLETE_INVISIBLE', function() {
            $scope.typeaheadVisible = false;
        });

        $scope.keywordSearchEnterKeyHandler = function() {
            $log.debug("keywordSearchEnterKeyHandler called");
            $scope.keywordSearch();
        };

        $scope.typeAheadSelect = function(item) {
            $log.debug("typeAheadSelect called");
            if (item.type !== 'KEYWORD') {
                $scope.actorSearch(item.metadata.Id, item.emailListDisplayName);
            } else {
                $scope.keywordSearch();
            }
        };

        /**
         * Search users and groups. Notify the typeahead if one of them is returned from the service.
         * Then, resolve the typeahead promise with the remaining list.
         */
        var userAndGroupResults = [],
            userResults = [],
            groupResults = [],

            //We maintain scoped variables below to discard previous searches
            lastSearchUid = null, //holds the last search ID
            searchUid = 0, //scoped counter, incremented every time searchUsersAndGroups is called

            keywordHeaderText = $translate.instant('ANALYTICS.SEARCH_KEYWORD_GROUP_HEADER'),
            TOTAL_NUM_REQUESTS = 2;

        function resultsWithNewUsers(users) {
            userResults = users;
            userAndGroupResults = userResults.concat(groupResults);
            return userAndGroupResults;
        }

        function resultsWithNewGroups(groups) {
            groupResults = groups;
            userAndGroupResults = userResults.concat(groupResults);
            return userAndGroupResults;
        }

        function postProcessResults(query, results) {
            var filteredResults = results.filter(function(collabWrapper) {
                return collabWrapper.type !== AppConstants.CollaboratorTypes.INVITE;
            });
            return [{
                type : 'KEYWORD',
                shouldShowHeader : true,
                typeaheadDisplayName : query,
                headerDisplayName : keywordHeaderText
            }].concat(filteredResults);
        }

        $scope.searchUsersAndGroups = function(query) {
            var deferred = $q.defer(),
                localRequestId = searchUid,
                completeCount = 0,
                searchUsersParams = {
                    reuseLastSearchOnError: true
                };

            // Search a user without a delay, and make the last request update user results.
            lastSearchUid = searchUid;
            searchUid += 1;

            TypeaheadService.searchUsers(query, searchUsersParams).then(
                function resolveSuccess(userCollaboratorWrappers) {
                    completeCB(userCollaboratorWrappers, resultsWithNewUsers);
                },
                function resolveFailure() {
                    completeCB([], resultsWithNewUsers);
                });

            TypeaheadService.searchGroups(query).then(
                function resolveSuccess(groupCollaboratorWrappers) {
                    completeCB(groupCollaboratorWrappers, resultsWithNewGroups);
                },
                function resolveFailure() {
                    completeCB([], resultsWithNewGroups);
                });

            function completeCB(results, resultsFn) {
                // All old search results will be ignored.
                if (lastSearchUid === localRequestId) {
                    completeCount += 1;

                    if (completeCount === TOTAL_NUM_REQUESTS) {
                        deferred.resolve(postProcessResults(query, resultsFn(results)));
                    } else {
                        deferred.notify(postProcessResults(query, resultsFn(results)));
                    }
                }
            }
            //notify() does not work ahead-of-time, meaning before returning the promise reference to the caller
            //The idea behind the below notify is that, we should show keyword search immediately w/o waiting on showing "Users" and "Groups" searches (which takes time to get data from the server)
            $timeout(function() {
                deferred.notify(postProcessResults(query, []));
            });
            return deferred.promise;
        };

        $scope.getAnalytics = function(loadMoreResults) {
        	$scope.inputOrganizationId = null;
        	$scope.inputUserId = null;
        	if ($scope.queryFormData.showSitewideActivity){
        		$scope.inputOrganizationId = userInfo.OrganizationId;
        		$scope.inputUserId = $routeParams.actorId;
        	}
            var params = {
                queryCategory: queryCategory,
                query: $scope.__createQueryData(loadMoreResults),
                organizationId : $scope.inputOrganizationId,
                userId : $scope.inputUserId,
                limit: 50
            },
            data;

            if ($scope.pageMarker && loadMoreResults) {
                //The GET request params should have small case "m"arker, but the reponse JSON will have "M"arker
                params.marker = $scope.pageMarker;
            }

            $scope.__createFilterButtons();
            $scope.layout.serviceError = false;
            if (!loadMoreResults) {
                $scope.layout.searchInProgress = true;
                //Clear old results when it's not loading more scenario
                $scope.searchResultGroups = [];
            }

            //The cached params are used later for exporting
            $scope.cachedParams = params;
            AnalyticsService.getAnalytics(params).then(function(response) {
                data = angular.fromJson(response.data);
                //we need to set the loading state to false here, because the groupResultsByDate() could trigger loadMore
                $scope.layout.searchInProgress = false;
                $scope.layout.loadMoreInProgress = false;

                if (!flagFlippedAfterGettingFirstTimeResults && _.isEmpty($routeParams) && data.Items.length) {
                    var topActivityTimeDiff = Date.now() - new Date(data.Items[0].Fields.ActivityTime).getTime();
                    //Emit a metric for default page loads i.e., without searching etc.,
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "ActivityFeed.FreshnessScore",
                        MetricName: "Time",
                        Unit: "Milliseconds",
                        Values: topActivityTimeDiff
                    });
                    flagFlippedAfterGettingFirstTimeResults = true;
                }
                if (loadMoreResults && data.Marker === $scope.pageMarker) {
                    //It means there are no more pages
                    $scope.pageMarker = null;
                } else {
                    $scope.pageMarker = data.Marker;
                    data.Items = $scope.__filterActivityResults(data.Items);
                    $scope.__groupResultsByDate(data.Items);
                }
            }, function(err) {
                $log.error(err.message);
                //If the session has timedout then retry after 7 seconds
                if (err.status === AppConstants.HttpStatuses.UNAUTHORIZED) {
                    $timeout($scope.getAnalytics.bind($scope, loadMoreResults), 7 * 1000);
                    return;
                }
                //Empty the search results in case of error
                $scope.searchResultGroups = [];
                $scope.pageMarker = null;

                $scope.layout.serviceError = true;
                $scope.layout.searchInProgress = false;
                $scope.layout.loadMoreInProgress = false;
            });
        };

        $scope.exportFeed = function() {
            var params = angular.copy($scope.cachedParams);
            if (!params) {
                //If the results are not fetched, don't do anything
                return;
            }
            if (typeof params.query.From === 'string') {
                params.query.From = new Date(Date.parse(params.query.From));
            }
            if (params.query.From.getTime() === minimumDate.getTime()) {
                var lastGroup = $scope.searchResultGroups[$scope.searchResultGroups.length - 1];
                var lastGroupItem = lastGroup.searchResults[lastGroup.searchResults.length - 1];
                params.query.From = new Date(lastGroupItem.Fields.ActivityTime);
            }
            CompanionService.exportActivityFeed(JSON.stringify(params.query), params.userId, params.organizationId, params.queryCategory);
        };

        $scope.applyFilter = function() {
            $location.search('filter', JSON.stringify($scope.queryFormData));
        };

        $scope.loadMoreResults = function() {
            if ($scope.layout.loadMoreInProgress || !$scope.pageMarker) {
                return;
            }
            $scope.layout.loadMoreInProgress = true;
            $scope.getAnalytics(true);
        };

        $scope.__isActivityEmpty = function(activity) {
            return !activity || !activity.Fields;
        };

        $scope.getActivityIcon = function(activity) {
            var iconName = '';
            switch (activity.Fields.ActivityType) {

                case 'DOCUMENT_COMMENT_ADDED':
                case 'DOCUMENT_ANNOTATION_ADDED':
                    iconName = 'comments';
                    break;

                case 'DOCUMENT_COMMENT_DELETED':
                case 'DOCUMENT_ANNOTATION_DELETED':
                    iconName = 'decline-feedback';

                    break;

                case 'DOCUMENT_VERSION_UPLOADED':
                    iconName = 'upload-to-cloud';
                    break;

                case 'FOLDER_CREATED':
                    iconName = 'add-folder';
                    break;

                case 'DOCUMENT_VERSION_DELETED':
                case 'DOCUMENT_VERSIONS_DELETED':
                case 'FOLDER_DELETED':
                    iconName = 'trash';
                    break;

                case 'FOLDER_RECYCLED':
                case 'DOCUMENT_RECYCLED':
                    iconName = 'remove';
                    break;

                case 'FOLDER_RESTORED':
                case 'DOCUMENT_RESTORED':
                case 'FOLDER_RECOVERED':
                case 'DOCUMENT_RECOVERED':
                case 'DOCUMENT_VERSIONS_RECOVERED':
                    iconName = 'restore';
                    break;

                case 'FOLDER_MOVED':
                case 'DOCUMENT_MOVED':
                    iconName = 'move';
                    break;

                case 'DOCUMENT_SHARED':
                case 'DOCUMENT_SHAREABLE_LINK_CREATED':
                case 'DOCUMENT_SHAREABLE_LINK_PERMISSION_CHANGED':
                case 'DOCUMENT_SHARE_PERMISSION_CHANGED':
                case 'FOLDER_SHARED':
                case 'FOLDER_SHAREABLE_LINK_CREATED':
                case 'FOLDER_SHARE_PERMISSION_CHANGED':
                case 'FOLDER_SHAREABLE_LINK_PERMISSION_CHANGED':
                case 'DOCUMENT_ANONYMOUS_LINK_CREATED':
                    iconName = 'share';
                    break;

                case 'DOCUMENT_SHAREABLE_LINK_REMOVED':
                case 'DOCUMENT_UNSHARED':
                case 'FOLDER_UNSHARED':
                case 'FOLDER_SHAREABLE_LINK_REMOVED':
                case 'DOCUMENT_ANONYMOUS_LINK_REMOVED':
                    iconName = 'remove-me-from-share';
                    break;

                case 'DOCUMENT_RENAMED':
                case 'FOLDER_RENAMED':
                case 'DOCUMENT_ANONYMOUS_LINK_EXPIRYDATE_CHANGED':
                    iconName = 'edit-file';
                    break;

                case 'DOCUMENT_REVERTED':
                case 'DOCUMENT_CHECKED_IN':
                    iconName = 'unlocked';
                    break;

                case 'DOCUMENT_CHECKED_OUT':
                    iconName = 'locked';
                    break;
                case 'DOCUMENT_VERSION_DOWNLOADED':
                    iconName = 'download-from-cloud';
                    break;
                case 'DOCUMENT_VERSION_VIEWED':
                    iconName = 'open-folder';
                    break;

            }
            if (!iconName) {
                if (activity.Fields.ResourceType === resourceTypes.DOCUMENT) {
                    iconName = 'default';
                } else if (activity.Fields.ResourceType === resourceTypes.FOLDER) {
                    iconName = 'folder-lg';
                } else {
                    iconName = 'default';
                }
            }
            return 'work-docs-icon-' + iconName + '-212f3e-24x24';
        };

        $scope.getActivityTime = function(activity) {
            var Fields = activity.Fields;
            var dateObj = new Date(Fields.ActivityTime),
                dateObjClone = new Date(Fields.ActivityTime),
                today = new Date();
            dateObj.setHours(0,0,0,0); //ignore time part
            today.setHours(0,0,0,0);
            if (dateObj.getTime() === today.getTime()) {
                return moment(dateObjClone).fromNow();
            }
            return DateFormatter.toReadableDate(dateObjClone);
        };

        $scope.getExpiryTime = function(expiryDate) {
        	var dateObjClone = new Date(expiryDate);
        	return $filter('date')(new Date(dateObjClone), 'MM/dd/yyyy');
        };

        $scope.getResourceUrl = function(activity) {
            var Fields = activity.Fields;
            var url = (Fields.ResourceType === resourceTypes.DOCUMENT ? '#/document/' + Fields.ResourceId : '#/folder/' + Fields.ResourceId);

            if (Fields.CommentId) {
                if (Fields.ActivityType === 'DOCUMENT_ANNOTATION_ADDED') {
                    url += '?AnnotationId=' + Fields.CommentId;
                } else if (Fields.ActivityType === 'DOCUMENT_COMMENT_ADDED') {
                    url += '?CommentId=' + Fields.CommentId;
                }
            }
            if(Fields.TargetPrincipalType === 'ANONYMOUS'){
            	url = (Fields.ResourceType === resourceTypes.DOCUMENT ? '#/share/document/' + Fields.ResourceId : '#/share/folder/' + Fields.ResourceId);
            }
            return url;
        };

        $scope.resetAllSearchParams = function() {
            //First remove both the fields and then set the fields accordingly
            $location.search('actorId', null);
            $location.search('actorName', null);

            $location.search('filter', null);
            $location.search('documentId', null);
            $location.search('folderId', null);
            $location.search('keyword', null);
            $location.search('resourceName', null);
        };

        //A very big assumption, ResourceType field will always be either 'document' or 'folder'
        $scope.openDetail = function(activity) {
            $scope.resetAllSearchParams();
            var Fields = activity.Fields;

            if (Fields.ResourceType === resourceTypes.DOCUMENT) {
                $location.search('documentId', Fields.ResourceId);
            } else {
                $location.search('folderId', Fields.ResourceId);
            }
            $location.search('resourceName', Fields.ResourceName);
        };

        /**
         * Special logic for handling descriptions for move to/from Root folders
         * @param activity The activity object which contains the related info
         */
        $scope.__getActivityDescriptionKey = function(activity) {
            var Fields = activity.Fields;
            var keyPrefix = 'ANALYTICS.ACTIVITY_TYPE.';

            if (Fields.InitiatorActorId === "anonymous") {
                keyPrefix += 'ANONYMOUS_USER.';
            }

            if (Fields.InitiatorActorId === userInfo.Id) {
                keyPrefix += 'SELF.';
            } else if ( (Fields.TargetActorId === userInfo.Id && (Fields.ActivityType === 'DOCUMENT_SHARED' || Fields.ActivityType === 'DOCUMENT_UNSHARED' ||
                Fields.ActivityType === 'FOLDER_SHARED' || Fields.ActivityType === 'FOLDER_UNSHARED')) ||
                (Fields.CommentRecipientId === userInfo.Id && (Fields.ActivityType === 'DOCUMENT_COMMENT_ADDED' || Fields.ActivityType === 'DOCUMENT_ANNOTATION_ADDED')) ) {
                keyPrefix += 'SELF_TARGET.';
            }

            if (Fields.AnonymousLinkExpiryDate === undefined  ) {
            	if (Fields.ActivityType === 'DOCUMENT_ANONYMOUS_LINK_EXPIRYDATE_CHANGED') {
            		return keyPrefix + 'DOCUMENT_ANONYMOUS_LINK_EXPIRYDATE_REMOVED';
            	} else if (Fields.ActivityType === 'DOCUMENT_ANONYMOUS_LINK_CREATED'){
            		return keyPrefix + 'DOCUMENT_ANONYMOUS_LINK_CREATED_FOREVER';
            	}
            }

            //Assumption is that activity.Fields.ActivityType is unique across folders and documents.
            if (Fields.ActivityType === 'DOCUMENT_MOVED') {
                if (Fields.MoveFromRootFolderOwnerName) {
                    return keyPrefix + 'UI.DOCUMENT.MOVE_FROM_ROOT_FOLDER';
                } else if (Fields.MoveToRootFolderOwnerName) {
                    return keyPrefix + 'UI.DOCUMENT.MOVE_TO_ROOT_FOLDER';
                }
            } else if (Fields.ActivityType === 'FOLDER_MOVED') {
                if (Fields.MoveFromRootFolderOwnerName) {
                    return keyPrefix + 'UI.FOLDER.MOVE_FROM_ROOT_FOLDER';
                } else if (Fields.MoveToRootFolderOwnerName) {
                    return keyPrefix + 'UI.FOLDER.MOVE_TO_ROOT_FOLDER';
                }
            } else if (Fields.CommentRecipientName) {
                //If you have a CommentRecipientName then it's a reply case
                return keyPrefix + 'REPLY.' + Fields.ActivityType;
            }
            return keyPrefix + Fields.ActivityType;
        };

        $scope.isKnownActivity = function(activity) {
            var descriptionText,
                descriptionKey = $scope.__getActivityDescriptionKey(activity);

            descriptionText = $translate.instant(descriptionKey);
            return descriptionText !== descriptionKey;
        };

        $scope.getActivityDescription = function(activity) {
            var Fields = activity.Fields;
            var descriptionText,
                descriptionKey = $scope.__getActivityDescriptionKey(activity);

            descriptionText = $translate.instant(descriptionKey, angular.extend({}, Fields, {
                ResourceUrl : $scope.getResourceUrl(activity),
                AnonymousLinkExpiryDate : $scope.getExpiryTime(Fields.AnonymousLinkExpiryDate),
                SharePermissionType : DocumentUtilities.roleToHumanString(Fields.SharePermissionType)
            }));
            if (descriptionText === descriptionKey) {
                descriptionText = $translate.instant('ANALYTICS.ACTIVITY_TYPE.UNKNOWN');
            }
            if (Fields.IndirectActivity === 'Y') {
                descriptionText += ' ' + $translate.instant('ANALYTICS.TOP_LEVEL_FOLDER_ACTIVITY', angular.extend({
                    ResourceUrl : '#/folder/' + Fields.IndirectActivityResourceId
                }, Fields));
            }
            return $sce.trustAsHtml(descriptionText);
        };

        $scope.setInitialStartDate = function() {
            if (!$scope.queryFormData.startDate) {
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                $scope.queryFormData.startDate = now;
            }
        };

        $scope.setInitialEndDate = function() {
            if (!$scope.queryFormData.endDate) {
                var now = new Date();
                now.setHours(23, 59, 59, 999);
                $scope.queryFormData.endDate = now;
            }
        };

        /**
         * Currently when user's are created two top level folders (My Documents and Recycle bin) are created
         * We don't want to list these folders in the Activity Feed hence we filter them out.
         */
        $scope.__filterActivityResults = function(results) {
            if (!results || !results.length) {
                return [];
            }
            return results.filter(function(activity) {
                if ($scope.__isActivityEmpty(activity)) {
                    return false;
                }
                var Fields = activity.Fields;
                if (Fields.ActivityType === 'FOLDER_CREATED' || Fields.ActivityType === 'FOLDER_DELETED') {
                    if (Fields.ResourceName === 'recycle-bin') {
                        return false;
                    }
                    if (Fields.ResourceName.match(rootFolderRegexp)) {
                        return false;
                    }
                }
                return true;
            });
        };

        $scope.__groupResultsByDate = function(resultItems) {
            if (!resultItems || !resultItems.length) {
                return;
            }
            var cache = {};
            resultItems.forEach(function(resultItem) {
                var groupName = DateTimeService.getTimePeriod(resultItem.Fields.ActivityTime);
                if (!cache[groupName]) {
                    var existingGroup = _.find($scope.searchResultGroups, function(group) {
                        return group.header === groupName;
                    });
                    if (!existingGroup) {
                        existingGroup = {
                            header : groupName,
                            searchResults : []
                        };
                        cache[existingGroup.header] = existingGroup.searchResults;
                        $scope.searchResultGroups.push(existingGroup);
                    }
                    existingGroup.searchResults.push(resultItem);
                } else {
                    cache[groupName].push(resultItem);
                }
            });

            var totalActivities = 0;
            $scope.searchResultGroups = $scope.searchResultGroups.filter(function(group) {
                //Only show activities for which there exists atleast english translation in strings_en.properties
                group.searchResults = (group.searchResults || []).filter($scope.isKnownActivity);                
                totalActivities += group.searchResults.length;
                return !!group.searchResults.length;
            });
            if (!areThereEnoughActivitesToCauseScroll(totalActivities)) {
                $scope.loadMoreResults();
            }
        };

        /**
         * This function is need to cause scroll bar in the activity feed. If the scroll bar doesn't appear, then the
         * pagination does not work as it's tied to the scroll event.
         */
        function areThereEnoughActivitesToCauseScroll(totalActivities) {
            var heightOfPageHeaderPlusSearchForm = 140; //this is the height of page header + search field. It's constant
            var heightOfEachActivity = 60; //Each activity takes 60px to render. It's also constant
            var availableHeight = window.screen.height - heightOfPageHeaderPlusSearchForm;
            return totalActivities > (availableHeight / heightOfEachActivity);
        }

        $scope.__openContainingFolderFailureCallbackFn = function(response) {
            MessageManager.addErrorMessage($translate.instant('ANALYTICS.FILE_ACTIONS.OPEN_CONTAINING_FOLDER.ERROR'));
            return response;
        };

        $scope.openContainingFolder = function(activity) {
            var Fields = activity.Fields;
            var promise;
            if (Fields.ResourceType === resourceTypes.DOCUMENT) {
                promise = DocumentService.getDocumentPath(Fields.ResourceId);
            } else {
                promise = FileService.getFolderPath(Fields.ResourceId);
            }
            promise.then(function(response) {
                var data =response.data,
                    resourceId;

                if (!data || !data.Path || !data.Path.Components || !data.Path.Components[0] || !data.Path.Components[0].Id) {
                    $scope.__openContainingFolderFailureCallbackFn();
                    return;
                }
                if (data.Path.Components.length > 1) {
                    //The above condition means the user has access to parent folder
                    //We should check the penultimate entry to access the parent folder ID
                    resourceId = data.Path.Components[data.Path.Components.length - 2].Id;
                } else {
                    //the file is directly shared with the user
                    $location.url('/shared?highlightResourceId=' + Fields.ResourceId);
                }

                if (resourceId === userInfo.RootFolderId) {
                    $location.url('/mydocs?highlightResourceId=' + Fields.ResourceId);
                } else if (resourceId === userInfo.RecycleBinFolderId) {
                    $location.url('/recycle?highlightResourceId=' + Fields.ResourceId);
                } else if (resourceId) {
                    //fromSearch flag will make the user go to Shared With Me page if the folder cannot be loaded (if the user does not have access)
                    $location.url('/folder/' + resourceId + '?fromSearch=true&highlightResourceId=' + Fields.ResourceId);
                }
                return response;
            }, $scope.__openContainingFolderFailureCallbackFn);
        };

        $scope.getNoResultsMessageForResourceSearch = function() {
            return $translate.instant('ANALYTICS.RESULT.WITH_RESOURCE.NORESULT', {
                ResourceName : $scope.layout.resourceName
            });
        };

        /*
         * This method will return null if there is no disable reason, which means the export button should be enabled
         * So the return value of this function can also be used to determine if export button should be enabled.
         */

        $scope.getExportDisabledReason = function() {
            var msg = null;

            if (BrowserService.isMobileOrTablet()) {
                msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.DEVICE_NOT_SUPPORTED');
            } else if (!CompanionService.isCompanionConnectionPossible()) {
                msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.BROWSER_NOT_SUPPORT');
            } else if (!$rootScope.companionDownloadButtonClicked && Utils.compareVersion(EXPORT_ACTIVITY_MIN_COMPANION_VERSION, CompanionClientService.getClient().getCompanionVersion()) > 0) {
                msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.OLD_COMPANION', {
                    companionDownloadUrl: CompanionService.getCompanionDownloadUrl()
                });
            }

            // if there is no reason, return null
            return msg;
        };

        $scope.markCompanionAsInstalled = function() {
            $rootScope.companionDownloadButtonClicked = true;
        };

        /**
         * This method is responsible for creating request JSON object. It overrides some flags such as
         * ResourceId as per the search query params.
         */
        $scope.__createQueryData = function(loadMoreResults) {
            var query = {},
                todayEarlyMorning,
                todayMidnight;

            todayEarlyMorning = new Date();
            todayEarlyMorning.setHours(0, 0, 0, 0);

            var yesterdayEarlyMorning = new Date(todayEarlyMorning.getTime() - 24 * 60 * 60 * 1000);

            todayMidnight = new Date();
            todayMidnight.setHours(23, 59, 59, 999);

            //Always take the previous queriedSearchFileName instead of new param while loading more results
            if (loadMoreResults && $scope.layout.queriedSearchFileName) {
                query.ResourceName = $scope.layout.queriedSearchFileName;
            } else if ($scope.queryFormData.searchFileName && !loadMoreResults) {
                query.ResourceName = $scope.queryFormData.searchFileName;
            }
            //We use "queriedSearchFileName" to show the text "Showing results for xxxx file or filename"
            $scope.layout.queriedSearchFileName = query.ResourceName;
            query.ActivityTypes = [];
            $scope.queryFormData.activityTypes.forEach(function(activityType) {
                if (activityType.enabled) {
                    query.ActivityTypes = query.ActivityTypes.concat(activityType.criteria);
                }
            });

            if ($routeParams.activityTypes) {
                query.ActivityTypes = $routeParams.activityTypes.split(',');
            }

            if (!query.ActivityTypes.length) {
                //Remove the property if the length of the array is zero
                delete query.ActivityTypes;
            }

            if ($scope.queryFormData.dateModified === 'TODAY') {
                query.From = todayEarlyMorning;
                query.To = todayMidnight;
            } else if ($scope.queryFormData.dateModified === 'YESTERDAY') {
                query.From = yesterdayEarlyMorning;
                query.To = new Date(todayEarlyMorning.getTime() - 1);
            } else if ($scope.queryFormData.dateModified === 'LAST_SEVEN'){
                query.From = new Date();
                query.From.setHours(0, 0, 0, 0);
                query.From.setDate(query.From.getDate() - 7);
            } else if ($scope.queryFormData.dateModified === 'LAST_THIRTY'){
                query.From = new Date();
                query.From.setHours(0, 0, 0, 0);
                query.From.setDate(query.From.getDate() - 30);
            } else if ($scope.queryFormData.dateModified === 'CUSTOM') {
                if ($scope.queryFormData.startDate) {
                    query.From = $scope.queryFormData.startDate;
                }
                if ($scope.queryFormData.endDate) {
                    query.To = $scope.queryFormData.endDate;
                }
            }
            if ($routeParams.folderId) {
                query.ResourceId = $routeParams.folderId;
            } else if ($routeParams.documentId) {
                query.ResourceId = $routeParams.documentId;
            }
            if ($routeParams.actorId && !$scope.queryFormData.showSitewideActivity) {
                query.SearchActorId = $routeParams.actorId;
            }
            if (!query.From) {
                query.From = new Date(minimumDate);
            }
            if (!query.To) {
                query.To = todayMidnight;
            }
            if ($routeParams.from) {
                query.From = new Date(Date.parse($routeParams.from)).toISOString();
            }
            if ($routeParams.to) {
                query.To = new Date(Date.parse($routeParams.to)).toISOString();
            }

            if ($scope.queryFormData.showSubFolderActivity) {
                query.ActivityScope = 'ALL';
            } else {
                query.ActivityScope = 'DIRECT';
            }
            return query;
        };

        if ($routeParams.filter) {
            $scope.queryFormData = JSON.parse($routeParams.filter);
        }

        //If the $routeParams contains documentId OR folderId, it should also contain resourceName so you can use it.
        //It's mandatory to have resourceName because we cannot find out the name of deleted documents or folders
        if ($routeParams.documentId) {
            $scope.layout.documentId = $routeParams.documentId;
            $scope.layout.resourceName = $routeParams.resourceName;
        } else if ($routeParams.folderId) {
            $scope.layout.folderId = $routeParams.folderId;
            $scope.layout.resourceName = $routeParams.resourceName;
        } else if ($routeParams.keyword) {
            $scope.queryFormData.searchFileName = $routeParams.keyword;
        }

        $scope.layout.searchInProgress = true;
        $scope.cachedParams = null;
        //Initialization code
        $scope.getAnalytics();
    }
}(angular));
